import { toast } from 'react-toastify';
import notificationSound from '../assets/notification.mp3';

const audio = new Audio(notificationSound);

export const NotificationType = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
  WARNING: 'warning'
};

export const showNotification = ({
  title,
  body,
  type = NotificationType.INFO,
  sound = true,
  duration = 5000,
  desktop = true
}) => {
  // Show toast notification
  toast[type](body, {
    position: "bottom-right",
    autoClose: duration,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });

  // Play sound if enabled
  if (sound) {
    audio.play().catch(err => console.log('Audio playback failed:', err));
  }

  // Show desktop notification if enabled and permitted
  if (desktop && "Notification" in window) {
    try {
      if (Notification.permission === "granted") {
        new Notification(title, {
          body,
          icon: '/logo192.png',
          badge: '/favicon.ico',
          timestamp: Date.now(),
          requireInteraction: false
        });
      } else if (Notification.permission !== "denied") {
        Notification.requestPermission().then(permission => {
          if (permission === "granted") {
            new Notification(title, {
              body,
              icon: '/logo192.png',
              badge: '/favicon.ico',
              timestamp: Date.now(),
              requireInteraction: false
            });
          }
        });
      }
    } catch (error) {
      console.error('Desktop notification failed:', error);
    }
  }
};

// Usage examples:
export const notifySuccess = (title, body) => showNotification({
  title,
  body,
  type: NotificationType.SUCCESS
});

export const notifyError = (title, body) => showNotification({
  title,
  body,
  type: NotificationType.ERROR,
  duration: 7000
});

export const notifyInfo = (title, body) => showNotification({
  title,
  body,
  type: NotificationType.INFO,
  sound: false
});

export const notifyWarning = (title, body) => showNotification({
  title,
  body,
  type: NotificationType.WARNING
});